import { render, staticRenderFns } from "./lowcode.vue?vue&type=template&id=5f5c2bda&scoped=true&"
import script from "./lowcode.vue?vue&type=script&lang=js&"
export * from "./lowcode.vue?vue&type=script&lang=js&"
import style0 from "./lowcode.vue?vue&type=style&index=0&id=5f5c2bda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5c2bda",
  null
  
)

export default component.exports